import {useMutation} from '@apollo/client';
import {DeleteAccountDocument} from '@transactions/graphql';
import * as React from 'react';
import {setAccounts} from 'src/apolloCache/updateAccounts';
import {Button} from 'src/Button';
import {Modal} from 'src/Modal';
import type {ApolloCache, FetchResult} from '@apollo/client';
import type {DeleteAccountMutation} from '@transactions/graphql';
import type {SystemProps} from 'src/Modals';

// Minimal type for the account to be deleted
type AccountForDelete = {
  _id: string;
  name: string;
};

export type DeleteAccountModalUserProps = {
  account: AccountForDelete;
  onDeleted?: (deleted: AccountForDelete) => void;
};

export const DeleteAccountModal = (
  props: DeleteAccountModalUserProps & SystemProps,
) => {
  const {account, onRequestClose} = props;
  const [deleteAccount, {loading}] = useMutation(DeleteAccountDocument);

  const handleDelete = (event: React.FormEvent) => {
    event.preventDefault();
    deleteAccount({
      variables: {accountId: account._id},
      update: (
        store: ApolloCache<object>,
        result: FetchResult<DeleteAccountMutation>,
      ) => {
        const updatedAccounts = result.data?.deleteAccount;
        if (updatedAccounts) {
          setAccounts(store, updatedAccounts);
        }
      },
    }).then(() => {
      props.onDeleted?.(account);
      onRequestClose();
    });
  };

  const footer = (
    <>
      <Button variant="outline" onClick={onRequestClose} disabled={loading}>
        Cancel
      </Button>
      <Button
        variant="destructive"
        type="submit"
        onClick={handleDelete}
        disabled={loading}
      >
        Delete account
      </Button>
    </>
  );

  return (
    <Modal
      onRequestClose={onRequestClose}
      header="Delete account"
      footer={footer}
    >
      <p>
        Are you sure you want to delete <strong>{account.name}</strong>? This
        action cannot be undone.
      </p>
    </Modal>
  );
};
